import React from 'react';
import Autocomplete from 'react-autocomplete';
//<88181>
const Filtros = props => (
  <div>
    <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>	
    <div className='row col-md-12'>
	  	  
			<div className='col-md-2'>
					<select className='form-control' id='familiaFilter' onChange={props.onChangeAndShowMarcas}
					  name='familiaFilter' value={props.familiaFilter}>
					  <option value=''>Familia</option>
					  {
						props.listaFamilias.map(familia => (
						  <option
							key={familia.codigo}
							value={familia.codigo}>
							{familia.descripcion}
						  </option>
						))
					  }
					</select>
					<div className='select-control-icon'><i className='ion-arrow-down-b' /></div>		
			</div>
							
			<div className='col-md-2'>				 
					<select className='form-control' id='marcaFilter' onChange={props.onChangeAndShowModelos}
					  name='marcaFilter' value={props.marcaFilter}>
					  <option value=''>Marca</option>
					  {
						props.listaMarcas.map(marca => (
						  <option
							key={marca.codigo}
							value={marca.codigo}>
							{marca.descripcion}
						  </option>
						))
					  }
					</select>
					<div className='select-control-icon'><i className='ion-arrow-down-b' /></div>		
			</div>
			
			<div className='col-md-3'>					
					<Autocomplete
					inputProps={{   className: 'form-control',     placeholder: 'codigo',        name: 'codigoModelo',    size: '5'      }}
					wrapperStyle={{ display: 'inline-block',           position: 'relative',              zIndex: '10',            }}
					menuStyle={{    position: 'absolute', left: '0', top: '100%', maxHeight: '250px',  overflow: 'auto', border: '1px solid #cccccc', }}
					name='codigoModelo'	 	
					items={
					  props.listaModelos.filter(({ codBaumuster }) => codBaumuster.toLowerCase()
													.indexOf(props.codigoModelo.toLowerCase())>=0)
					}
					getItemValue={item => item.codBaumuster}
					renderItem={(item, isHighlighted) =>
						  <div key={item.codBaumuster} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
							{item.codBaumuster}
						  </div>
					}	 
					onChange={props.onChangeValue}
					onSelect={key => props.selectModeloxCod(key)}
					value={props.codigoModelo} />					
						
				   <Autocomplete
					inputProps={{   className: 'form-control',     placeholder: 'Modelo',        name: 'nombreModelo',          }}
					wrapperStyle={{ display: 'inline-block',           position: 'relative',              zIndex: '10',            }}
					menuStyle={{    position: 'absolute', left: '0', top: '100%', maxHeight: '250px', overflow: 'auto', border: '1px solid #cccccc', }}
					name='nombreModelo'	 	
					items={
					  props.listaModelos.filter(({ desBaumuster }) => desBaumuster.toLowerCase()
													.indexOf(props.nombreModelo.toLowerCase())>=0)
					}
					getItemValue={item => item.codBaumuster}
					renderItem={(item, isHighlighted) =>
						  <div key={item.codBaumuster} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
							{item.desBaumuster}
						  </div>
					}	 
					onChange={props.onChangeValue}
					onSelect={key => props.selectModeloxDes(key)}
					value={props.nombreModelo} />				  
			 </div>	  
			 
	
			 
			 <div className='col-md-3'>			
			 
					<Autocomplete
					inputProps={{   className: 'form-control',     placeholder: 'codigo',        name: 'codigoConfig',    size: '5'      }}
					wrapperStyle={{ display: 'inline-block',           position: 'relative',              zIndex: '10',            }}
					menuStyle={{    position: 'absolute', left: '0', top: '100%', maxHeight: '250px',  overflow: 'auto', border: '1px solid #cccccc', }}
					name='codigoConfig'	 	
					items={
					  props.listaConfigur.filter(({ codigo }) => codigo.toLowerCase()
													.indexOf(props.codigoConfig.toLowerCase())>=0)
					}
					getItemValue={item => item.codigo}
					renderItem={(item, isHighlighted) =>
						  <div key={item.codigo} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
							{item.codigo}
						  </div>
					}	 
					onChange={props.onChangeValue}
					onSelect={key => props.selectConfiguracionxCod(key)}
					value={props.codigoConfig} />		
						
				  <Autocomplete
					inputProps={{   className: 'form-control',     placeholder: 'Configuracion',        name: 'nombreConfig',          }}
					wrapperStyle={{ display: 'inline-block',           position: 'relative',              zIndex: '10',            }}
						menuStyle={{    position: 'absolute', left: '0', top: '100%', maxHeight: '250px', overflow: 'auto', border: '1px solid #cccccc', }}
					name='nombreConfig'	 	
					items={
					  props.listaConfigur.filter(({ descripcion }) => descripcion.toLowerCase()
													.indexOf(props.nombreConfig.toLowerCase())>=0)
					}
					getItemValue={item => item.codigo}
					renderItem={(item, isHighlighted) =>
						  <div key={item.codigo} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
							{item.descripcion}
						  </div>
					}	 
					onChange={props.onChangeValue}
					onSelect={key => props.selectConfiguracionxDes(key)}
					value={props.nombreConfig} />
				 
			 </div>				
				
		 	 <div className='col-md-1'>
						<input  style={{width:'60px', height:'30px'}}
						onChange={ props.onChangetext}
						placeholder="SKU"    
						type='text'  id='skuFilter'
						name='skuFilter'
						value={props.skuFilter}/>								
			</div>
						
			<div className='col-md-1'>		
				<div   style={{backgroundColor:'#f5f5f5',    pointerEvents: 'auto'}}>    
					 <button className="btn btn-blue" onClick={()=>props.searchBuscar()}>Buscar</button>							
				</div>     	
             </div>		    

      </div>
      <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar' data-toggle='tooltip' data-placement='top' 
	          title='Limpiar filtros' data-original-title='Limpiar filtros' onClick={props.reset}>
        <i className='ion-funnel' />
      </button>
    </div>
  </div>
  </div>
    );

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/Filtros.js